import qs from "qs";

export const getQueryParam = (query, field, defaultValue = null) => {
  const params = qs.parse(query, { ignoreQueryPrefix: true });

  return params && params[field] ? params[field] : defaultValue;
};
